import React from 'react'
import Link from 'gatsby-link'
import './style.scss'
import bodyScrollLock from '../../global/js/bodyScrollLockHandler'

class Nav extends React.Component {
  constructor () {
    super()
    this.state = {
      isOpen: false,
      hasStickyNav: false
    }
    this.hamburgerMenuClickHandler = this.hamburgerMenuClickHandler.bind(this)
    this.handleScroll = this.handleScroll.bind(this)
    this.replaceNavItem = this.replaceNavItem.bind(this)
  }

  hamburgerMenuClickHandler () {
    this.setState({isOpen: !this.state.isOpen})
    setTimeout(() => {
      bodyScrollLock(this.state.isOpen)
    })
  }

  componentWillMount () {
    this.setState({isOpen: false})
    bodyScrollLock(this.state.isOpen)
  }

  componentDidMount () {
    if (typeof window === 'undefined') return
    window.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount () {
    if (typeof window === 'undefined') return
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll () {
    let distanceFromTop = document.documentElement.scrollTop
    let header = typeof document !== 'undefined' ? document.getElementById('header-wrapper') : undefined
    if (!header) return
    let headerHeight = header.clientHeight

    if (window.innerWidth > 768) {
      if (distanceFromTop >= headerHeight) this.setState({hasStickyNav: true})
      if (distanceFromTop < headerHeight) this.setState({hasStickyNav: false})
    }
  }

  replaceNavItem (navItems) {
    navItems.forEach((item) => {
      if (item.pageName === 'Login') {
        item.pageName = 'Members'
      }
    })
  }

  render () {
    const navClasses = this.state.isOpen ? 'js-navOpen' : ''
    const navItems = this.props.data.navigationItems
    this.context.userObject ? this.replaceNavItem(navItems) : ''
    return (
      <div className={`nav-sticky ${this.state.hasStickyNav ? 'nav-sticky--fixed' : ''}`}>
        <nav className={`nav ${navClasses}`}>
          <div className={`nav-wrapper ${navClasses}`}>
            <div className='container'>
              <div className='combo'>
                <div className='combo-first'>
                  <Link className='nav-logo-anchor' to='/'>
                    <img className={`nav-logo ${this.state.hasStickyNav ? 'nav-logo--fixed' : ''}`} src='/images/logo.svg' alt='logo' />
                  </Link>
                </div>
                <div className='combo-last u-verticalAlignMiddle u-alignRight'>
                  <div className={`nav-mobileWrapper ${navClasses}`}>
                    <ul className='nav-itemsWrapper'>
                      {navItems.map((item, i) => {
                        const linkName = item.pageName
                        const linkUrl = item.pageName.toLowerCase()
                        return (
                          <li className={`nav-item ${this.state.hasStickyNav ? 'nav-item--fixed' : ''}`} key={i}>
                            <Link to={`/${linkUrl}`} activeClassName={'nav-item--current'} onClick={linkUrl === 'log out' ? (e) => this.logOut(e) : ''}>{linkName}</Link>
                          </li>
                        )
                      })}
                    </ul>
                  </div>
                  <ul className={`hamburger ${navClasses}`} onClick={() => this.hamburgerMenuClickHandler()}>
                    <li className='hamburger-patty' />
                    <li className='hamburger-patty' />
                    <li className='hamburger-patty' />
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </div>
    )
  }
}

Nav.contextTypes = {
  userObject: React.PropTypes.object
}

export default Nav



// WEBPACK FOOTER //
// ./src/components/nav/index.js